import styled from 'styled-components';
import { Media } from 'enums';
import { Button } from 'view/atoms';

export const NoArchivePage = styled.div`
  width: 100%;
  padding: 30px 20px 100px;
  background-color: #f5f5f4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const GoHomeButton = styled(Button)`
  margin-top: 30px;
  margin-bottom: 100px;

  @media ${Media.tablet} {
    margin-bottom: 242px;
  }
  @media ${Media.notebook} {
    margin-top: 54px;
    margin-bottom: 136px;
    min-height: 64px;
  }

  @media ${Media.desktop} {
    margin-bottom: 210px;
  }
`;
